import modelBaseV2 from "../model-base-v2.model";

const SiteUDFCustomerModel = {
  getCustomerList: () => {
    return modelBaseV2.get('/api/siteUDFCustomer/list');
  },
}

export default SiteUDFCustomerModel;  